<template>
  <div>
    <!-- 导出报表对话框 -->
    <el-dialog
      :title="title"
      :visible.sync="exportVisible"
      width="800px"
      :before-close="handleClose"
    >
      <div>
        <ul class="exportData">
          <li v-if="filesType === 24">
            <span class="export-left">报表维度</span>
            <el-radio-group v-model="exportParams.tableRange">
              <el-radio label="2">
按任务
</el-radio>
              <el-radio label="1">
按导购
</el-radio>
            </el-radio-group>
          </li>
          <li v-if="showDateSelect">
            <span class="export-left">导出范围</span>
            <template>
              <!-- 按天导出 -->
              <el-date-picker
                v-if="exportDate === 'date' && isDateSingle"
                v-model="exportParams.date"
                :style="{ width: '360px', marginRight: '20px' }"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                :picker-options="includeCurrentDate ? currentPickerDateOptions : pickerDateOptions"
              />

              <!-- 按起始天导出 -->
              <el-date-picker
                v-if="exportDate === 'date' && !isDateSingle"
                v-model="exportParams.dateRange"
                :style="{ width: '360px', marginRight: '20px' }"
                type="daterange"
                range-separator="至"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="includeCurrentDate ? currentPickerDateOptions : pickerDateOptions"
              />

              <!-- 按月导出 -->
              <el-date-picker
                v-if="exportDate === 'month' && isDateSingle"
                v-model="exportParams.date"
                :style="{ width: '360px', marginRight: '20px' }"
                type="month"
                value-format="yyyy-MM"
                placeholder="选择月份"
                :picker-options="
                  includeCurrentDate ? currentpickerMonthOptions : pickerMonthOptions
                "
              />

              <!-- 按起始月份导出 -->
              <el-date-picker
                v-if="exportDate === 'month' && !isDateSingle"
                v-model="exportParams.dateRange"
                :style="{ width: '360px', marginRight: '20px' }"
                type="monthrange"
                range-separator="至"
                value-format="yyyy-MM"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
                :picker-options="pickerMonthOptions"
              />
              <!-- <el-button
                type="text"
                @click="goExportList"
              >
                查看导出列表
              </el-button> -->
            </template>
          </li>

          <li v-if="showStoreSelect || (filesType === 24 && exportParams.tableRange === '1')">
            <span class="export-left">选择门店</span>
            <el-input
              v-model="storeNum"
              placeholder="全部门店"
              disabled
              :style="{ width: '360px' }"
            >
              <div slot="append">
                <el-link
type="primary"
style="margin-right: 10px"
@click="storeVisible = true"
>
                  编辑
                </el-link>
                <el-link
type="primary"
@click="clearStore"
>
重置
</el-link>
              </div>
            </el-input>
          </li>

          <li v-if="showCommunitySelect">
            <span class="export-left">选择社群</span>
            <el-button
type="text"
size="small"
@click="communityVisible = true"
>
              已选择{{
                selectCommunityData.length ? selectCommunityData.length + '个' : '全部'
              }}社群
            </el-button>
          </li>

          <li v-if="showEmployeeStatus || (filesType === 24 && exportParams.tableRange === '1')">
            <span class="export-left">导出类型</span>
            <el-radio-group v-model="exportParams.employee_status">
              <el-radio label="0">
全部
</el-radio>
              <el-radio label="1">
员工
</el-radio>
              <el-radio label="2">
编外
</el-radio>
              <el-radio
v-if="showOrderStatus"
label="3"
>
群订单
</el-radio>
            </el-radio-group>
          </li>

          <!-- 结算状态 -->
          <li v-if="showSettlementStatus">
            <span class="export-left">结算状态</span>
            <el-radio-group v-model="exportParams.settlement_status">
              <el-radio label="2">
已确认
</el-radio>
              <el-radio label="1">
未确认
</el-radio>
              <el-radio label="3">
上月提成订单退款扣减
</el-radio>
            </el-radio-group>
          </li>

          <!-- 订单导出特殊处理 -->
          <li v-if="showOrderStatus">
            <span class="export-left">订单状态</span>
            <el-select
              v-model="exportParams.order_status"
              multiple
              placeholder="全部状态"
              style="width: 360px"
              @change="statusChange"
            >
              <el-option
                v-for="(item, index) in statusList"
                :key="index"
                :label="item.label"
                :value="item.name"
              />
            </el-select>
          </li>
          <!-- <li v-if="listType">
            <span class="export-left">报表类型</span>
            <el-radio-group v-model="exportParams.file_type">
              <el-radio label="new">
                添加客户
              </el-radio>
              <el-radio label="bind">
                绑定客户
              </el-radio>
            </el-radio-group>
          </li> -->

          <li v-if="showChannel">
            <span class="export-left">添加渠道</span>
            <el-autocomplete
              v-model="channelName"
              style="width: 360px"
              :fetch-suggestions="querySearch"
              placeholder="请输入内容"
              clearable
              @select="handleSelect"
            />
          </li>

          <li v-if="showSalesPersonStatus || (filesType === 24 && exportParams.tableRange === '1')">
            <span class="export-left">导购状态</span>
            <el-radio-group v-model="exportParams._status">
              <el-radio label="1">
全部
</el-radio>
              <el-radio label="2">
在职
</el-radio>
              <el-radio label="3">
离职
</el-radio>
            </el-radio-group>
          </li>

          <li v-if="showStoreStatus">
            <span class="export-left">门店状态</span>
            <el-radio-group v-model="exportParams._status">
              <el-radio label="1">
全部
</el-radio>
              <el-radio label="2">
开店中
</el-radio>
              <el-radio label="3">
已闭店
</el-radio>
            </el-radio-group>
          </li>

          <li>
            <span class="export-left" />
            <el-button
type="primary"
:loading="createLoading"
@click="gradeExport"
>
              导出报表
            </el-button>
            <el-button
type="text"
@click="goExportList"
>
查看导出列表
</el-button>
          </li>
        </ul>
      </div>

      <div class="tips">
        <slot />
      </div>
    </el-dialog>

    <!-- 编辑门店对话框 -->
    <SpStoreSelect
      v-model="storeVisible"
      :select-data="selectStoreData"
      @chooseStore="chooseStore"
    />

    <!-- 编辑社群对话框 -->
    <SpCommunitySelect
      v-model="communityVisible"
      :select-data="selectCommunityData"
      @chooseCommunity="chooseCommunity"
    />
  </div>
</template>

<script>
export default {
  name: 'SpExportList',
  model: {
    prop: 'exportVisible',
    event: 'exportVisibleChange'
  },
  props: {
    exportVisible: {
      type: Boolean, //模态框展示隐藏
      default: false
    },
    filesType: {
      type: [Number, String], //导出报表的类型，必须传值
      default: 1 // [1:业绩excel  2:导购码zip 3.社群业绩excel 4.社群招新导购维度excel 5.社群列表导出 6.店铺业绩按天导出 7.订单列表导出] |默认1 8.导出导购任务 ｜ 24.按导购导出
    },
    listType: {
      type: String,
      default: '' // 客户招新统计：来源哪个列表 store 按门店统计 ；salesperson 按导购统计
    },
    exportDate: {
      type: String, //报表导出范围日期格式：按天导出date；按月导出month; 默认按天导出
      default: 'date'
    },
    title: {
      type: String, //报表导出标题
      default: '报表导出'
    },
    showDateSelect: {
      type: Boolean, //展示日期选择
      default: true
    },
    showStoreSelect: {
      type: Boolean, //展示门店选择
      default: false
    },
    showCommunitySelect: {
      type: Boolean, //展示社群选择
      default: false
    },
    showEmployeeStatus: {
      type: Boolean, //展示导出类型员工状态
      default: false
    },
    showOrderStatus: {
      type: Boolean, //展示导出订单状态
      default: false
    },
    showChannel: {
      type: Boolean, // 展示渠道来源筛选项
      default: false
    },
    showSettlementStatus: {
      type: Boolean, // 展示结算状态
      default: false
    },
    isDateSingle: {
      type: Boolean, // true则是单日期选择类型  false是起始日期选择类型
      default: false
    },
    includeCurrentDate: {
      type: Boolean, // 是否包含当前天 月，默认不包含
      default: false
    },
    tabType: {
      type: String, //自定义tab类型
      default: ''
    },
    addParams: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isPlugin: {
      type: Boolean, // 来源是否是插件
      default: false
    },
    showSalesPersonStatus: {
      type: Boolean, // 是否显示导购状态
      default: false
    },
    showStoreStatus: {
      type: Boolean, // 是否显示门店状态
      default: false
    }
  },
  data () {
    return {
      selfFilesType:null,
      pickerDateOptions: {
        disabledDate (date) {
          return date.getTime() > new Date().setDate(new Date().getDate() - 1)
        }
      },
      currentPickerDateOptions: {
        disabledDate (date) {
          return date.getTime() > new Date()
        }
      },
      pickerMonthOptions: {
        disabledDate (date) {
          return date.getTime() > new Date().setMonth(new Date().getMonth() - 1)
        }
      },
      currentpickerMonthOptions: {
        disabledDate (date) {
          return date.getTime() > new Date().setMonth(new Date().getMonth())
        }
      },
      exportParams: {
        dateRange: [], //导出日期
        employee_status: '0',
        order_status: [],
        file_type: 'new',
        date: '',
        settlement_status: '2',
        _status: '1',
        tableRange: '2'
      },
      storeVisible: false, //选择门店的对话框展示
      selectStoreData: [], //选择门店数据

      storeIds: -1, //选择门店的id
      createLoading: false,
      chatIds: -1, //选择社群的id
      communityVisible: false, //选择社群的对话框展示
      selectCommunityData: [], //选择社群数据

      statusList: [
        { name: 'notpay', label: '待付款' },
        { name: 'refundsuccess', label: '已取消' },
        { name: 'notship', label: '待发货' },
        { name: 'shipping', label: '待收货' },
        { name: 'finish', label: '已完成' },
        { name: 'ziti', label: '待核销' }
      ],
      storeNum: '',
      channelList: [],
      channelName: '',
      timeout: null
    }
  },
  watch: {
    exportVisible (newVal) {
      if (newVal) {
        this.exportParams.dateRange = []
        this.exportParams.employee_status = '0'
        this.selectStoreData = []
        this.storeIds = -1
        this.chatIds = -1
      }
    },
    showChannel: {
      immediate: true,
      handler (val) {
        if (val) {
          this.getCannelList()
        }
      }
    }
  },
  mounted () {
    
    console.log('listType')
    console.log(this.listType)
  },
  methods: {
    querySearch (queryString, cb) {
      let channelList = this.channelList
      let results = queryString ? channelList.filter(this.createFilter(queryString)) : channelList
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter (queryString) {
      return (restaurant) => {
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
      }
    },
    handleSelect (item) {
      this.exportParams.channel_name = item.channel_name
    },
    async getCannelList () {
      const data = await this.$api.drainage.getChannelList({
        page: 1,
        page_size: 9999
      })
      if (data) {
        data.list.forEach((v) => (v.value = v.channel_name))
        this.channelList = data.list
      }
    },
    // 关闭导出报表对话框
    handleClose () {
      this.$emit('exportVisibleChange', false)
    },

    // 选择门店
    chooseStore (selectdata, storeids) {
      if (selectdata.length > 0) {
        this.selectStoreData = selectdata
        this.storeIds = storeids
        this.storeNum = '已选择' + selectdata.length + '家门店'
      } else {
        this.selectStoreData = []
      }
      this.storeVisible = false
    },
    //重置门店选择
    clearStore () {
      this.selectStoreData = []
      this.storeIds = []
      this.storeNum = ''
    },

    // 选择社群数据
    chooseCommunity (selectdata, ids) {
      if (selectdata.length > 0) {
        this.selectCommunityData = selectdata
        this.chatIds = ids
      } else {
        this.selectCommunityData = []
        this.chatIds = 0
      }
      this.communityVisible = false
    },

    // 订单状态动态查询
    statusChange (value) {
      let arr = JSON.parse(JSON.stringify(value))
      this.exportParams.order_status = arr
    },

    // 生成报表
    gradeExport () {
      const { dateRange, date, channel_name } = this.exportParams
      let obj = {}

      if (this.showDateSelect) {
        obj = {
          start_date: dateRange ? dateRange[0] || '' : '',
          end_date: dateRange ? dateRange[1] || '' : ''
        }

        if (!this.isDateSingle && (!obj.start_date || !obj.end_date)) {
          return this.$message.error('请选择导出范围')
        }
        if (this.isDateSingle && !date) {
          return this.$message.error('请选择导出时间')
        }

        if (this.exportDate === 'date' && this.isDateSingle) {
          obj = {
            date: date
          }
        }

        // 按月导出
        if (this.exportDate === 'month' && !this.isDateSingle) {
          obj = {
            start_month: dateRange ? dateRange[0] || '' : '',
            end_month: dateRange ? dateRange[1] || '' : ''
          }
        }
        if (this.exportDate === 'month' && this.isDateSingle) {
          obj = {
            month: date
          }
        }
      }

      if (this.showStoreSelect || (this.filesType === 24 && this.exportParams.tableRange === '1')) {
        obj.store_id = this.storeIds
        if (!obj.store_id) {
          return this.$message.error('请选择门店')
        }
      } else if (this.showCommunitySelect) {
        obj.chat_ids = this.chatIds
        if (!obj.chat_ids) {
          return this.$message.error('请选择社群')
        }
      }

      if (this.showChannel) {
        obj.channel_name = channel_name
        if (!obj.channel_name) {
          return this.$message.error('请选择渠道')
        }
      }

      if (this.tabType) {
        obj.tab_type = this.tabType
      }

      if (this.addParams) {
        obj = Object.assign({}, obj, this.addParams)
      }
      this.createExport(obj)
    },

    // 生成报表请求接口
    async createExport (item) {
      const { order_status, employee_status, file_type, settlement_status } = this.exportParams
      this.createLoading = true
      let params = {
        ...item
      }
      this.selfFilesType = this.filesType
      delete params.files_type
      if(this.filesType == '24' || this.filesType == '8'){
        params.files_type = this.exportParams.tableRange === '1' ? '24' : '8'
        this.selfFilesType = params.files_type
      }
      if (this.showEmployeeStatus) {
        params.employee_status = employee_status
      }
      
      if (this.filesType === 24 && this.exportParams.tableRange === '1') {
        if (employee_status === '1') {
          params.employee_status = 'employee'
        }
        if (employee_status === '2') {
          params.employee_status = 'external_employee'
        }
      }
      if (this.showOrderStatus) {
        params.order_status = order_status || []
      }
      if (this.listType) {
        params.list_type = this.listType
        // params.file_type = file_type
      }

      // 结算状态
      if (this.showSettlementStatus) {
        params.order_status = settlement_status
      }

      if (this.showSalesPersonStatus) {
        params.salesperson_status = this.exportParams._status
      }

      if (params.filesType === 24 && this.exportParams.tableRange === '1') {
        params.status = this.exportParams._status
        
      }

      if (this.showStoreStatus) {
        params.store_status = this.exportParams._status
      }

      console.log(params,  this.filesType,'paramsparamsparams')
      const data = await this.$api.file.createExportList(params, this.selfFilesType).catch(() => {
        this.createLoading = false
      })
      if (data && data.download_data) {
        this.createLoading = false
        const a = document.createElement('a')
        a.href = data.download_data.url
        a.download = data.download_data.file_name
        a.click()
      } else if (data && !data.download_data) {
        this.createLoading = false
        this.$message({
          message: '请求成功，异步处理中，请稍后到 导出列表 进行下载！',
          type: 'success'
        })
      }
    },

    // 跳转导出列表
    goExportList () {
      if (this.isPlugin) {
        this.$emit('goExportList', this.filesType)
      } else {
        this.$router.push({
          path: '/staffManagement/exportList?filestype=' + this.filesType,
          replace: true
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.export-left {
  display: inline-block;
  width: 80px;
}
.exportData {
  li {
    margin-bottom: 20px;
  }
}
.reports-list {
  display: flex;
  line-height: 36px;
}
.reports-list-items {
  flex-grow: 1;
}
.dialog-footer {
  display: flex;
  justify-content: center;
}
.export-pagination {
  margin-top: 20px;
}
.tips {
  color: #999;
  font-size: 12px;
}
</style>
